/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    events: [],
    isLoading: false,
};
export const EventsSlice = createSlice({
    name: 'events',
    initialState,
    reducers: {
        setEvents: (state, action) => {
            state.events = action.payload;
        },
        setEventsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    },
});
export const { setEvents, setEventsLoading } = EventsSlice.actions;
export const selectEvents = (state) => state.events.events;
export const selectIsLoadingEvents = (state) => state.events.isLoading;
export default EventsSlice.reducer;
